import { useEffect, useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Philosophy from "@/components/site/Philosophy";
import Pricing from "@/components/site/Pricing";
import InstagramWork from "@/components/site/InstagramWork";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#FBF9F6] text-[#1C1B1A]">
      <Header scrolled={scrolled} />
      <Hero />
      <Marquee />
      <Services />
      <Philosophy />
      <Pricing />
      <InstagramWork />
      <Process />
      <Contact />
      <Footer />
    </main>
  );
}
